// // Components
// import NavBar from './NavBar';
// import CarouselPage from './CarouselPage';
// import About from './About';
// // import ProductPortfolio from './ProductProtfolio';
// import ServicePage from './Services';
// import JoinOurTeam from './joinOurTeam'
// import HealthcareBrochures from './HealthcareBrochures'
// import Footer from './Footer'
// import ClientSlider from './ClientSlider';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import BookDemo from './BookDemo';
import {Routes,Route} from 'react-router-dom'
import axios from 'axios';
// //ChatBot imports
// import ChatBot from './ChatBot/Chatbot'
// // import AdminPanel from './ChatBot/AdminPanel';


import Home from "./Home";
import ProductDetail from './ProductDetails';
import Customer from './Customber';

// Products Details Page
import Lims from './DetailsProduct/Limis'
import QualityControl from './DetailsProduct/QualtityControl'
import BloodBank from './DetailsProduct/BloodBank'
import PricingPage from './PricingPage';
// import JoinOurTeam from './joinOurTeam';
// import LocationTracker from './UsersData/LocationTracker'



const App = () => {
// useEffect(() => {
//   // fetchLocationFromBackend();
//   getUserIPAndLogin();
// }, []);
//  https://bot-bridge-backend-6grb.vercel.app
// http://localhost:5000
// const fetchLocationFromBackend = async () => {
//   try {
//     const res = await axios.get('http://localhost:5000/api/UsersDatas/location');
//     console.log('User Location:', res.data);
//   } catch (error) {
//     console.error('Failed to fetch location from backend:', error);
//   }
// };

const getUserIPAndLogin = async () => {    
  // https://ipapi.co/json/

  try {
    // const ipData = await fetch(' https://ipapi.co/json/').then(res => res.json());
    // const userIP = ipData.ip;

    // console.log('User IP:', userIP);

    // Correctly send it as an object
    const res = await axios.post('https://bot-bridge-backend-6grb.vercel.app/api/UsersDatas/location');

    console.log('User Location:', res.data);
  } catch (error) {
    console.error('Failed to fetch location from backend:', error);
  }
}

  // // Send this IP along with login data
  // await fetch('/login', {
  //   method: 'POST',
  //   headers: { 'Content-Type': 'application/json' },
  //   body: JSON.stringify({
  //     username: 'user123',
  //     password: 'password',
  //     ip: userIP
  //   })
  // });




// const fetchUserIPDetails = async () => {
//     try {
//       // Step 1: Get user's public IP
//       const ipRes = await fetch('https://api.ipify.org?format=json');
//       const { ip } = await ipRes.json();
//       console.log(ip);
//       console.log("entered ip method")
//       // Step 2: Get location details from IP
//       const locationRes = await fetch(`https://ipwho.is/${ip}`);
//       const locationData = await locationRes.json();
//         console.log(locationData);
        
//       if (!locationData.success) {
//         console.error('Failed to fetch location:', locationData.message);
//         return;
//       }

//       // Step 3: Send to backend
//       await fetch('http://localhost:5000/api/UsersDatas/save-data', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           ip: locationData.ip,
//           city: locationData.city,
//           region: locationData.region, 
//           country: locationData.country,
//           latitude: locationData.latitude,
//           longitude: locationData.longitude,
//           postal: locationData.postal,
//           isp: locationData.connection.isp,
//         }),
//       });
//     } catch (error) {
//       console.error('Error fetching IP details:', error);
//     }
//   };





 const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return (
    <div style={{ marginTop: '0px', }}>

            {/* <LocationTracker /> */}
             <Routes>
              
             <Route path="/" element={<Home />} />
             <Route path="/book-demo" element={<BookDemo />} />
             <Route path='/customer' element={<Customer />} />
             <Route path='/LIMS' element={<Lims/>}/>
             <Route path='/Quality Control'element={<QualityControl/>} />
             <Route path='/Hospital Information System' element={<BloodBank/>}/>
             <Route path="/product/:id" element={<ProductDetail/>} />
             <Route path='/pricing' element={<PricingPage/>}/>
             
             </Routes>
              
              
              
              
              
              
              {/* <AdminPanel /> */}
              
  
     
      </div>
      
  );

}
export default App;
